import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Toaster, toast } from "sonner";
import { api, setSession, getUser } from "../lib/api";
import { BrandMark, Footer, Spinner } from "../components/Brand";

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  // already logged in? redirect after mount
  useEffect(() => {
    const u = getUser();
    if (u) {
      const dest = u.role === "im" ? "/im" : u.role === "obgyn" ? "/obgyn" : "/admin";
      navigate(dest, { replace: true });
    }
  }, [navigate]);

  async function doLogin(e) {
    e?.preventDefault?.();
    if (!email || !password) {
      toast.error("Veuillez saisir email et mot de passe");
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setSession(data);
      const dest = data.user.role === "im" ? "/im" : data.user.role === "obgyn" ? "/obgyn" : "/admin";
      navigate(dest, { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erreur de connexion");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex flex-col" style={{ background: "var(--cs-bg)" }}>
      <Toaster position="top-center" richColors />
      <div className="flex-1 flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-[440px] cs-fade">
          <div className="mb-10"><BrandMark size="lg" /></div>
          <form onSubmit={doLogin} className="cs-card p-7 flex flex-col gap-4" data-testid="login-screen">
            <div>
              <label className="cs-label block mb-2">Email professionnel</label>
              <input
                type="email"
                className="cs-input"
                placeholder="medecin@hopital.fr"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email"
                autoComplete="email"
              />
            </div>
            <div>
              <label className="cs-label block mb-2">Mot de passe</label>
              <input
                type="password"
                className="cs-input"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                autoComplete="current-password"
              />
            </div>
            <button type="submit" className="cs-btn-primary mt-2" disabled={busy} data-testid="login-submit">
              {busy ? <Spinner /> : "Se connecter"}
            </button>
            <Link
              to="/forgot"
              className="text-center text-[13px] mt-1 hover:underline"
              style={{ color: "var(--cs-text-muted)" }}
              data-testid="forgot-link"
            >
              Mot de passe oublié ?
            </Link>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}
